import { sizes } from "../../../constants/sizes";
import { useRef } from "react";
import { ReactComponent as TrimIcon } from "../../../svgs/trim.svg";

import { useReactToPrint } from "react-to-print";

const Trim = ({ project, editProject }) => {
  

  const { kitName, size } = project;

  const componentRef = useRef();
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });

  return (
    <div className="sheet-comp-container">
      <div className="sheet-input">
        <div id="sheet-print-button" onClick={handlePrint}>
          print
        </div>
      </div>
      <div className="sheet-output" ref={componentRef}>
        <div className="sheet-title">
          <div className="sheet-icon-title">
            <TrimIcon />
            <div>Trim</div>
          </div>
          <div>
            {kitName} - {sizes[size]}
          </div>
        </div>
        <div className="sheet-body">
          <div className="sheet-column">

          </div>
        </div>
      </div>
    </div>
  );
};

export default Trim;
